(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[121],{

/***/ 77088:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purchase/select-seats",
      function () {
        return __webpack_require__(71228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 81744:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
const { en: selectSeats  } = __webpack_require__(21450);
module.exports = {
    ...common,
    ...selectSeats,
    "select-seats-form": __webpack_require__(60188),
    "select-seats-page": __webpack_require__(64740)
};


/***/ }),

/***/ 37166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(81744),
    de: __webpack_require__(45597)
};


/***/ }),

/***/ 94554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 96127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    "select-seats": __webpack_require__(24112)
};


/***/ }),

/***/ 21450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(96127),
    de: __webpack_require__(94554)
};


/***/ }),

/***/ 71228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ select_seats; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/props-resolver.js
var props_resolver = __webpack_require__(77915);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/parsers/parseNumber.js
var parseNumber = __webpack_require__(73193);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Form/index.js + 1 modules
var Form = __webpack_require__(22950);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Select/index.js + 1 modules
var Select = __webpack_require__(89271);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/FormField/index.js + 7 modules
var FormField = __webpack_require__(85725);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Title.js
var Title = __webpack_require__(70504);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Description.js
var Description = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18-formats/currency.js
var currency = __webpack_require__(66728);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/useTracking/index.js
var useTracking = __webpack_require__(59074);
// EXTERNAL MODULE: ./src/nprogress.js
var nprogress = __webpack_require__(24753);
// EXTERNAL MODULE: ./src/persistent-storage/index.js + 2 modules
var persistent_storage = __webpack_require__(11095);
// EXTERNAL MODULE: ./src/purchaseTypes.js
var purchaseTypes = __webpack_require__(68028);
// EXTERNAL MODULE: ./src/services/auth.js + 4 modules
var auth = __webpack_require__(5803);
;// CONCATENATED MODULE: ./src/SelectSeatsForm/action.js






const savePriceItem = (context)=>(planCode, seats, price)=>(0,persistent_storage/* ref */.iH)(context).PriceItem.write({
            purchaseType: purchaseTypes/* SUBSCRIPTION */.NK,
            planCode,
            seats,
            price
        });
const gotoBillingInfo = (param, routerAction)=>{
    let { planCode , seats , price  } = param;
    savePriceItem()(planCode, seats, price);
    const urlToRedirect = (0,auth/* isAuthorized */.QO)() ? routes/* default.billingInfo */.ZP.billingInfo : "".concat(routes/* default.login */.ZP.login, "?returnUrl=").concat(encodeURIComponent(routes/* default.billingInfo */.ZP.billingInfo));
    return (0,routes/* navToPath */.SS)(urlToRedirect, urlToRedirect, routerAction);
};
/* harmony default export */ var action = ((0,pipe/* default */.Z)(gotoBillingInfo, (0,nprogress/* withLoading */.VT)("select-seats-action")));

// EXTERNAL MODULE: ./src/SelectSeatsForm/useSeats.js
var useSeats = __webpack_require__(81122);
;// CONCATENATED MODULE: ./src/SelectSeatsForm/hook.js




const priceToEntry = (param)=>{
    let { subscriptionSize , price , betterOption  } = param;
    return [
        subscriptionSize,
        {
            price,
            betterOption
        }
    ];
};
const compareDiff = (x)=>(a, b)=>Math.abs(x - a) - Math.abs(x - b);
const getSeats = (param)=>{
    let { subscriptionSize  } = param;
    return subscriptionSize;
};
const getInitialSeats = (initialSeats, priceList)=>{
    const defaultSeats = priceList.length > 0 ? getSeats(priceList[0]) : undefined;
    if (!initialSeats) return defaultSeats;
    return priceList.map(getSeats).sort(compareDiff(initialSeats))[0];
};
function useSelectSeatsForm(priceList, planCode, initialSeats) {
    const priceBySeats = (0,react.useMemo)(()=>new Map(priceList.map(priceToEntry)), [
        priceList
    ]);
    const firstSeats = (0,react.useMemo)(()=>getInitialSeats(initialSeats, priceList), []);
    const [goAhead, inProcess] = (0,useTracking/* default */.ZP)(action, useTracking/* CATCH */.av);
    const [seats, priceItem, setSeats] = (0,useSeats/* default */.Z)(firstSeats, priceBySeats);
    const { price , originSeats  } = priceItem;
    const updateSeats = (0,react.useCallback)((param)=>{
        let { target  } = param;
        return setSeats(parseInt(target.value, 10));
    }, [
        setSeats
    ]);
    const submitForm = (0,react.useCallback)((event)=>{
        if (event) event.preventDefault();
        goAhead({
            seats,
            planCode,
            price
        }, "push");
    }, [
        seats,
        planCode,
        price
    ]);
    return {
        planCode,
        seats,
        originSeats,
        updateSeats,
        price,
        submitForm,
        inProcess
    };
}
/* harmony default export */ var hook = (useSelectSeatsForm);

// EXTERNAL MODULE: ./src/SelectSeatsMessage/index.js
var SelectSeatsMessage = __webpack_require__(97886);
;// CONCATENATED MODULE: ./src/SelectSeatsForm/index.js

















const SelectSeatsForm_getSeats = (param)=>{
    let { subscriptionSize  } = param;
    return subscriptionSize;
};
const SelectSeatsForm = (param)=>{
    let { priceList , planCode , initialSeats  } = param;
    const [t] = (0,i18/* useLocale */.bU)("select-seats-form");
    const { seats , originSeats , price , updateSeats , inProcess , submitForm  } = hook(priceList, planCode, initialSeats);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                children: t("TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                children: t("DESCRIPTION")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                noValidate: true,
                onSubmit: submitForm,
                "data-qa-selector": "select-seats-form" // for e2e tesrts
                ,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        utility: {
                            justify: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            sm: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                required: true,
                                "data-qa-selector": "prices",
                                Control: Select/* default */.Z,
                                id: "prices",
                                name: "prices",
                                value: seats,
                                onChange: updateSeats,
                                disabled: inProcess,
                                children: Select/* default.renderOptions */.Z.renderOptions(priceList, SelectSeatsForm_getSeats, SelectSeatsForm_getSeats)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        utility: {
                            justify: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            sm: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectSeatsMessage/* default */.Z, {
                                seats: seats,
                                originSeats: originSeats
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                        sx: {
                                            fontSize: "xxxl",
                                            textAlign: "center"
                                        },
                                        className: "mt-4 mb-0",
                                        children: (0,currency/* default */.Z)(price)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                        sx: {
                                            fontSize: "s",
                                            textAlign: "center",
                                            textTransform: "uppercase"
                                        },
                                        spacing: {
                                            mt: 1,
                                            mb: 2
                                        },
                                        children: t("TOTAL")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                spacing: {
                                    mt: 4,
                                    mb: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                    sx: {
                                        textAlign: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "submit",
                                        disabled: inProcess,
                                        "data-qa-selector": "select-seats-submit-btn",
                                        className: (0,classes/* classes */.S)(inProcess && "disabled"),
                                        children: t("CONTINUE")
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
SelectSeatsForm.propTypes = {
    priceList: (0,prop_types.arrayOf)((0,prop_types.shape)({
        subscriptionSize: prop_types.number.isRequired,
        price: prop_types.number.isRequired,
        betterOption: prop_types.number
    })).isRequired,
    planCode: prop_types.string,
    initialSeats: prop_types.number
};
/* harmony default export */ var src_SelectSeatsForm = (SelectSeatsForm);

// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./src/utils/redirectIf/index.js
var redirectIf = __webpack_require__(12675);
// EXTERNAL MODULE: ./src/AppError/index.js + 10 modules
var AppError = __webpack_require__(38209);
// EXTERNAL MODULE: ./src/services/ecommerce.js + 15 modules
var ecommerce = __webpack_require__(33620);
// EXTERNAL MODULE: ./src/AppError/mapGraphQLErrors.js
var mapGraphQLErrors = __webpack_require__(20522);
// EXTERNAL MODULE: ./src/persistent-storage/hooks.js + 1 modules
var hooks = __webpack_require__(21777);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./locales/select-seats-page/index.js
var select_seats_page = __webpack_require__(37166);
var select_seats_page_default = /*#__PURE__*/__webpack_require__.n(select_seats_page);
;// CONCATENATED MODULE: ./pages/purchase/select-seats.js




















const SelectNumberOfSeatsPage = (props)=>{
    const [t] = (0,i18/* useLocale */.bU)("select-seats-page");
    (0,hooks/* usePersistentStorage */.y)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.ZP, {
                title: t("PAGE_TITLE"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                    content: t("META_ROBOTS_CONTENT")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_SelectSeatsForm, {
                    ...props
                })
            })
        ]
    });
};
SelectNumberOfSeatsPage.propTypes = {
    priceList: (0,prop_types.arrayOf)((0,prop_types.shape)({
        subscriptionSize: prop_types.number.isRequired,
        price: prop_types.number.isRequired,
        betterOption: prop_types.number
    })),
    planCode: prop_types.string,
    initialSeats: prop_types.number
};
const planCodeNotSpecified = (param)=>{
    let { query  } = param;
    return query.planCode == null;
};
SelectNumberOfSeatsPage.getInitialProps = (0,props_resolver/* default */.Z)({
    priceList: (context)=>(0,ecommerce/* default */.ZP)(context).getPrices(context.query.planCode),
    planCode: (param)=>{
        let { query  } = param;
        return query.planCode;
    },
    initialSeats: (param)=>{
        let { query  } = param;
        return (0,parseNumber/* default */.Z)(query.seats);
    }
});
const checkPriceListLength = (expected)=>{
    return (param)=>{
        let { priceList  } = param;
        return (priceList === null || priceList === void 0 ? void 0 : priceList.length) === expected;
    };
};
const savePriceItemAndGoToBillingInfo = (param, context)=>{
    let { planCode , priceList  } = param;
    const { subscriptionSize , price  } = priceList[0];
    savePriceItem(context)(planCode, subscriptionSize, price);
    return (0,auth/* isAuthorized */.QO)(context) ? routes/* default.billingInfo */.ZP.billingInfo //
     : (0,routes/* toLoginUrl */.WC)({
        returnUrl: routes/* default.billingInfo */.ZP.billingInfo
    });
};
/* harmony default export */ var select_seats = ((0,pipe/* default */.Z)(SelectNumberOfSeatsPage, (0,i18/* WithLocale */._t)({
    resources: (select_seats_page_default())
}), (0,redirectIf/* default */.ZP)(planCodeNotSpecified, routes/* default.external.howToBuy */.ZP.external.howToBuy), redirectIf/* default.afterPropsResolved */.ZP.afterPropsResolved([
    [
        checkPriceListLength(0),
        routes/* default.external.howToBuy */.ZP.external.howToBuy
    ],
    [
        checkPriceListLength(1),
        savePriceItemAndGoToBillingInfo
    ]
]), (0,redirectIf/* default */.ZP)(planCodeNotSpecified, routes/* default.external.howToBuy */.ZP.external.howToBuy), redirectIf/* default.onCatch */.ZP.onCatch(mapGraphQLErrors/* isNotFound */.I3, routes/* default.external.howToBuy */.ZP.external.howToBuy), AppError/* withErrorHandling */.b));


/***/ }),

/***/ 81122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const getFirstItemFromMap = (map)=>{
    const entries = map.entries();
    const item = entries.next().value;
    return item && item[1];
};
const getPriceBySeats = (priceBySeats, seats, originSeats)=>{
    const price = priceBySeats.get(seats) || getFirstItemFromMap(priceBySeats);
    return price.betterOption ? getPriceBySeats(priceBySeats, price.betterOption, originSeats || seats) : {
        ...price,
        newSeats: price.newSeats != null ? price.newSeats : seats,
        originSeats: originSeats || seats
    };
};
const getDefaultSeatsValue = (param)=>{
    let { newSeats  } = param;
    return newSeats;
};
function useSeats(initialSeats, priceBySeats) {
    let getSeatsValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getDefaultSeatsValue;
    const [price, setPrice] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>getPriceBySeats(priceBySeats, initialSeats));
    const handleSetSeats = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((value)=>{
        const priceItem = getPriceBySeats(priceBySeats, value);
        setPrice(priceItem);
    }, [
        priceBySeats
    ]);
    return [
        getSeatsValue(price),
        price,
        handleSetSeats
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useSeats);


/***/ }),

/***/ 97886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46003);
/* harmony import */ var _insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74229);





const SelectSeatsMessage = (param)=>{
    let { seats , originSeats , textAlign ="center" , ...props } = param;
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)("select-seats");
    return seats !== originSeats ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            fontSize: "s",
            textAlign,
            fontColor: "green"
        },
        spacing: {
            mt: 2,
            mb: 2
        },
        ...props,
        children: t("DISCOUNTS", {
            seats,
            originSeats
        })
    }) : null;
};
SelectSeatsMessage.propTypes = {
    seats: prop_types__WEBPACK_IMPORTED_MODULE_4__.number.isRequired,
    originSeats: prop_types__WEBPACK_IMPORTED_MODULE_4__.number.isRequired,
    textAlign: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectSeatsMessage);


/***/ }),

/***/ 21777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ useInMemoryStorage; },
  "y": function() { return /* binding */ usePersistentStorage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/persistent-storage/index.js + 2 modules
var persistent_storage = __webpack_require__(11095);
// EXTERNAL MODULE: ./src/utils/nextSignleton/index.js + 2 modules
var nextSignleton = __webpack_require__(74733);
;// CONCATENATED MODULE: ./src/persistent-storage/in-memory-storage.js

const inMemoryStorage = (value)=>({
        write: (newValue)=>{
            value = newValue; // eslint-disable-line no-param-reassign
        },
        read: ()=>value,
        clear: ()=>{
            value = undefined; // eslint-disable-line no-param-reassign
        }
    });
const BillingInfo = (0,nextSignleton/* default */.Z)(()=>inMemoryStorage());
const PriceItem = (0,nextSignleton/* default */.Z)(()=>inMemoryStorage());
const CancelSurvey = (0,nextSignleton/* default */.Z)(()=>inMemoryStorage());

// EXTERNAL MODULE: ./src/utils/global-context/hook.js
var hook = __webpack_require__(63841);
;// CONCATENATED MODULE: ./src/persistent-storage/hooks.js




const usePersistentStorage = ()=>{
    const context = (0,hook/* default */.Z)();
    (0,react.useMemo)(()=>{
        (0,persistent_storage/* ref */.iH)(context).setPriceItem(persistent_storage/* PriceItem */.gJ);
        (0,persistent_storage/* ref */.iH)(context).setBillingInfo(persistent_storage/* BillingInfo */.O1);
        (0,persistent_storage/* ref */.iH)(context).setCancelSurvey(persistent_storage/* CancelSurvey */.I$);
    }, [
        context
    ]);
};
const useInMemoryStorage = ()=>{
    const context = (0,hook/* default */.Z)();
    (0,react.useMemo)(()=>{
        (0,persistent_storage/* ref */.iH)(context).setPriceItem(PriceItem);
        (0,persistent_storage/* ref */.iH)(context).setBillingInfo(BillingInfo);
        (0,persistent_storage/* ref */.iH)(context).setCancelSurvey(CancelSurvey);
    }, [
        context
    ]);
};


/***/ }),

/***/ 60188:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TITLE":"SnapGene Subscription","DESCRIPTION":"Select the number of seats for your subscription.","TOTAL":"TOTAL","CONTINUE":"Continue","errors":{"NO_PLAN_CODE":"Couldn\'t Find Pricing Plan"}}');

/***/ }),

/***/ 64740:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PAGE_TITLE":"Select Seats - SnapGene","META_ROBOTS_CONTENT":"noindex, follow"}');

/***/ }),

/***/ 24112:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"DISCOUNTS":"Good news! We have updated your selection to {{seats}} instead of {{originSeats}} since volume discounts make this option less expensive."}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,4476,2458,3918,2774,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(77088); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);